/**
 * @generated SignedSource<<bd313c7e358052bd08eed86073223763>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type palettesWithColorsQuery$variables = {
  after?: string | null;
  first?: number | null;
  numberOfColorsToShow?: number | null;
  orderBy?: string | null;
  paletteTypeID?: number | null;
  search?: string | null;
};
export type palettesWithColorsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"colorPaletteSettings_palettesWithColors">;
};
export type palettesWithColorsQuery = {
  response: palettesWithColorsQuery$data;
  variables: palettesWithColorsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": "1",
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": 20,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": 6,
    "kind": "LocalArgument",
    "name": "numberOfColorsToShow"
  },
  {
    "defaultValue": "DESC",
    "kind": "LocalArgument",
    "name": "orderBy"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "paletteTypeID"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "search"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "numberOfColorsToShow",
    "variableName": "numberOfColorsToShow"
  },
  {
    "kind": "Variable",
    "name": "orderBy",
    "variableName": "orderBy"
  },
  {
    "kind": "Variable",
    "name": "paletteTypeID",
    "variableName": "paletteTypeID"
  },
  {
    "kind": "Variable",
    "name": "search",
    "variableName": "search"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "palettesWithColorsQuery",
    "selections": [
      {
        "args": (v1/*:: as any*/),
        "kind": "FragmentSpread",
        "name": "colorPaletteSettings_palettesWithColors"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "palettesWithColorsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "PalettesWithColorsConnection",
        "kind": "LinkedField",
        "name": "palettesWithColors",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PalettesWithColorsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Palette",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*:: as any*/),
                  (v3/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "useConversionTable",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "paletteTypeID",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isZakekeDefault",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PaletteColor",
                    "kind": "LinkedField",
                    "name": "colors",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "colorID",
                        "storageKey": null
                      },
                      (v3/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rgbHexCode",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cmykHexCode",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "spotColorName",
                        "storageKey": null
                      },
                      (v2/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "associationWithPrintTypes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "filters": [
          "search",
          "numberOfColorsToShow",
          "paletteTypeID",
          "orderBy"
        ],
        "handle": "connection",
        "key": "palettesWithColors_palettesWithColors",
        "kind": "LinkedHandle",
        "name": "palettesWithColors"
      }
    ]
  },
  "params": {
    "cacheID": "81027aad7eb09a873d4ae802042c687e",
    "id": null,
    "metadata": {},
    "name": "palettesWithColorsQuery",
    "operationKind": "query",
    "text": "query palettesWithColorsQuery(\n  $after: String = \"1\"\n  $first: Int = 20\n  $numberOfColorsToShow: Int = 6\n  $orderBy: String = \"DESC\"\n  $paletteTypeID: Int = null\n  $search: String = null\n) {\n  ...colorPaletteSettings_palettesWithColors_UJ1NN\n}\n\nfragment colorPaletteSettings_palettesWithColors_UJ1NN on Query {\n  palettesWithColors(first: $first, after: $after, search: $search, numberOfColorsToShow: $numberOfColorsToShow, paletteTypeID: $paletteTypeID, orderBy: $orderBy) {\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    edges {\n      cursor\n      node {\n        id\n        name\n        useConversionTable\n        paletteTypeID\n        isZakekeDefault\n        colors {\n          colorID\n          name\n          rgbHexCode\n          cmykHexCode\n          spotColorName\n          id\n        }\n        associationWithPrintTypes\n        __typename\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "390323d41f392f71e0b21726bf720b1e";

export default node;
